import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, forkJoin, map } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { DataForm, FieldTypes, Forms } from '../shared/interfaces/forms.interface';

const HOST = environment.host;

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  private http = inject(HttpClient);
  taxonomyUrl:string = `${HOST}/api/taxonomy_term`;

  getDocumentTypes(): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/document_type`, this.getHttpOptionsWithAuth()).pipe(
      map(resp => resp.data)
    );
  }

  getGenders(): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/gender`, this.getHttpOptionsWithAuth()).pipe(
      map(resp => resp.data)
    )
  }

  getCompanies(): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/company`, this.getHttpOptionsWithAuth()).pipe(
      map(resp => resp.data)
    )
  }

  getFieldsTypes(): Observable<FieldTypes>{
    return forkJoin([
      this.getDocumentTypes(),
      this.getGenders(),
      this.getCompanies()
    ]).pipe(
      map(([documentTypes, genders, companies]) => {
        return {
          documentTypes,
          genders,
          companies
        };
      })
    );
  }

  getDocumentTypeById(id: number): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/document_type/${id}`).pipe(
      map(resp => resp.data)
    )
  }

  getGenderById(id: number): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/gender/${id}`).pipe(
      map(resp => resp.data)
    )
  }

  getcompanyById(id: number): Observable<DataForm>{
    return this.http.get<Forms>(`${this.taxonomyUrl}/company/${id}`).pipe(
      map(resp => resp.data)
    )
  }

  private getHttpOptionsWithAuth(): { headers: HttpHeaders } {
    const headers = new HttpHeaders({
      'Authorization' : 'Basic dGVzdDp0ZXN0'
    });

    return { headers };
  }
}
